var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68.2 68.2",
    style: {
      enableBackground: "new 0 0 31 68.2"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#535AA7;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1C164E;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#347798;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#294A76;}\n"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 18.761539, -0.319594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,43.9v22c0,1.2-0.7,1.7-1.6,1.2L3.2,60.3c-1-0.7-1.6-1.8-1.6-3V35.8c0.2,0.1,0.4,0.3,0.6,0.4L17.2,43.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.9,33.4l24.9-12.8c0.8-0.5,1.3-1.4,1.4-2.4V2.7c0-1-0.6-1.4-1.4-1l-23,11.8c-2.4,1.3-3.5,1.9-3.3,4.6v14.4 C1.5,33.3,2.2,33.8,2.9,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.9,15.6l24.9,12.8c0.8,0.5,1.3,1.4,1.4,2.4v15.5c0,1-0.6,1.4-1.4,1L2.9,34.6c-0.8-0.5-1.4-1.4-1.4-2.4V16.6 C1.5,15.7,2.2,15.2,2.9,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.9,33.4l17.3-8.9L2.9,15.6c-0.3-0.2-0.7-0.2-1,0c-0.3,0.5-0.4,1-0.4,1.5v15.1c0,0.3,0.1,0.7,0.2,1 C2,33.5,2.5,33.7,2.9,33.4C2.9,33.4,2.9,33.4,2.9,33.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFio);
export default __webpack_public_path__ + "static/media/fio.8ef28e4ff75cb3d25db351e9e991e0df.svg";
export { ForwardRef as ReactComponent };